export default "__VITE_ASSET__fe1c7f98__"